// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-page {
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  background: #f8fafc;
  padding: 20px;
}

.register-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.register-modal {
  background: white;
  border-radius: 12px;
  padding: 20px;
  max-width: 600px;
  width: 100%;
  position: relative;
  z-index: 1;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      margin: 1rem;
}

.register-header {
  text-align: center;
  margin-bottom: 30px;
}

.register-header h2 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 10px 0;
}

.register-header p {
  font-size: 18px;
  color: #6b7280;
  margin: 0;
}

.register-form {
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-input {
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  color: #1f2937;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-input::placeholder {
  color: #9ca3af;
}

.full-width {
  grid-column: 1 / -1;
}

.terms-checkbox {
  margin: 10px 0;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
  transition: all 0.2s;
}

.checkbox-label input[type="checkbox"]:checked + .checkmark {
  background: #3b82f6;
  border-color: #3b82f6;
}

.checkbox-label input[type="checkbox"]:checked + .checkmark::after {
  content: "✓";
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.form-buttons {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 20px;
  justify-content: center;
}

.cancel-button {
  background: #f3f4f6;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
}

.cancel-button:hover {
  background: #e5e7eb;
  color: #374151;
}

.register-submit-button {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
}

.submit-button:hover:not(:disabled) {
  background: #2563eb;
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .register-modal {
    padding: 30px 20px;
    margin: 10px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-buttons {
    flex-direction: column;
  }
}
.register-container {
    min-height: auto;
    display: flex;
    position: relative;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-end;
    justify-content: center;
}
.error-message{
  color: red;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Register/Register.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,+CAA+C;MAC3C,YAAY;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;EACE,UAAU;EACV,eAAe;AACjB","sourcesContent":[".register-page {\n  min-height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  position: relative;\n  background: #f8fafc;\n  padding: 20px;\n}\n\n.register-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n.background-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.register-modal {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  max-width: 600px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n      margin: 1rem;\n}\n\n.register-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.register-header h2 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 10px 0;\n}\n\n.register-header p {\n  font-size: 18px;\n  color: #6b7280;\n  margin: 0;\n}\n\n.register-form {\n  display: flex;\n  flex-direction: column;\n  /* gap: 10px; */\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.form-input {\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  background: white;\n  color: #1f2937;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-input::placeholder {\n  color: #9ca3af;\n}\n\n.full-width {\n  grid-column: 1 / -1;\n}\n\n.terms-checkbox {\n  margin: 10px 0;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkmark {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #d1d5db;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 2px;\n  transition: all 0.2s;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkmark {\n  background: #3b82f6;\n  border-color: #3b82f6;\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked + .checkmark::after {\n  content: \"✓\";\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.form-buttons {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-end;\n  margin-top: 20px;\n  justify-content: center;\n}\n\n.cancel-button {\n  background: #f3f4f6;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 100px;\n}\n\n.cancel-button:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.register-submit-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 100px;\n}\n\n.submit-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .register-modal {\n    padding: 30px 20px;\n    margin: 10px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .form-buttons {\n    flex-direction: column;\n  }\n}\n.register-container {\n    min-height: auto;\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    align-items: flex-end;\n    justify-content: center;\n}\n.error-message{\n  color: red;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
